<template>
  <div
    class="default-title">
    <component
      :is="h_tag">
      <slot/>
    </component>
  </div>
</template>

<script>
export default {
  name: "DefaultTitle",
  props: {
    h_tag: {
      type: String,
      default: 'h2'
    },
  },
}
</script>
